import { useSelector } from "react-redux";
import { isEmpty } from "lodash";

export const useCheckIsWebSettings = () => {
    const isWebSettings = useSelector(
        state => state?.form?.["webpush-settings"],
    );
    return !isEmpty(isWebSettings);
};
